export default {
  init() {
    function maps_initialize() {
      const google = window.google;
      //var mapElem = document.getElementById('gMap');
      var mapElems = document.getElementsByClassName("google-map");
      if (!mapElems) return;

      for (let i = 0; i < mapElems.length; i++) {
        google.maps.event.addDomListener(window, "resize", function () {
          var center = map.getCenter();
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        });

        var center = {
          lat: Number.parseFloat(mapElems[i].dataset.lat),
          lng: Number.parseFloat(mapElems[i].dataset.lng),
        };
        var myLatLng = {
          lat: Number.parseFloat(mapElems[i].dataset.lat),
          lng: Number.parseFloat(mapElems[i].dataset.lng),
        };
        var mapOptions = {
          center: center,
          scrollwheel: true,
          draggable: true,
          zoom: 14,
          zoomControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          styles: [{ stylers: [{ saturation: -0 }, { hue: "#fba542" }] }],
        };
        var map = new google.maps.Map(mapElems[i], mapOptions);

        var contentString = mapElems[i].dataset.address;

        var infowindow = new google.maps.InfoWindow({
          content: contentString,
        });

        var tdlMarker = new google.maps.Marker({
          position: myLatLng,
          map: map,
          icon: {
            scaledSize: new google.maps.Size(45, 45),
            url: window.google_map.icon,
          },
          title: "TDL Creative",
          labelContent: "TDL Creative",
          optimised: false,
        });

        var overlay = new google.maps.OverlayView();

        overlay.draw = function () {
          this.getPanes().markerLayer.id = "tdl-contact";
        };

        overlay.setMap(map);

        google.maps.event.addListener(tdlMarker, "click", () =>
          infowindow.open(map, tdlMarker)
        );
      }

      // Responsive map
    }

    // Initialise the map.
    window.google.maps.event.addDomListener(window, "load", maps_initialize);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js